import { render, staticRenderFns } from "./OpsEnableAlertsCard.vue?vue&type=template&id=6586138b&scoped=true"
import script from "./OpsEnableAlertsCard.vue?vue&type=script&lang=js"
export * from "./OpsEnableAlertsCard.vue?vue&type=script&lang=js"
import style0 from "./OpsEnableAlertsCard.vue?vue&type=style&index=0&id=6586138b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586138b",
  null
  
)

export default component.exports